const translations = {
  landing: {
    price: '$6.950 al mes, con 10 días de prueba gratuitos.',
  },
  faq: {
    price: '$6.950',
  },
  main: {
    menu: {
      seasons: 'ESTACIONES',
      stories: 'Cuentos',
      puppets: 'Cuentos con títeres',
      songs: 'Canciones',
      poems: 'Juego de palabras',
      meet: 'Conozcamos a',
      crafts: 'Manualidades',
      workshops: 'Talleres',
      games: 'Juegos',
      others: 'Guía de uso',
      search: 'Búsqueda',
      login: 'Entrar',
      account: 'Mi cuenta',
    },
    button: {
      account: 'Mi cuenta',
      login: 'Login',
    }
  },
  login: {
    title: 'Bienvenido a Chungungo',
    label: {
      email: 'Correo electrónico',
      password: 'Contraseña',
    },
    warning: {
      noemail: 'Debes ingresar tu correo',
      badpassword: 'Contraseña no puede estar en blanco'
    },
    button: {
      submit: 'Entrar',
      recovery: 'Recuperar contraseña',
      register: 'Registrarse'
    },
    alert: {
      noauth: 'Correo y contraseña equivocados, vuelve a intentarlo',
      mailnotvalid: 'No has validado que el correo sea tuyo, sigue el link que te hemos enviado',
    },
    password_reset:{
      modal: {
        error: 'Correo no encontrado, revisa que esté bien escrito en el inicio de sesión',
        title: 'Cambiar contraseña',
        message: 'Te enviamos un correo que contiene un enlace donde podrás cambiar tu contraseña',
        buttons: {
          send: 'Aceptar',
        }
      }
    },
    modal: {
      title: 'Entrar en Chungungo',
      buttons: {
        register: 'Registrarse',
        forgot_password: 'Olvidé mi contraseña',
      }
    }
  },
  register: {
    title: 'Registro',
    description: 'Necesitamos algunos datos de ti para crear tu cuenta',
    label: {
      name: 'Nombre',
      email: 'Correo electrónico',
      password: 'Contraseña',
    },
    button: {
      submit: 'Crea tu cuenta'
    },
    alert: {
      error: 'Hay datos que nos faltan sobre ti o tus contraseñas no coinciden'
    },
    validation: {
      email: 'Necesitamos tu correo electrónico',
      name: 'Necesitamos saber cómo te llamas',
      password: 'Debes escribir una contraseña, lo más segura posible',
    },
    modal: {
      title: 'Bienvenido a Chungungo',
      message: 'Necesitamos ahora que revises tu correo y sigas el link que te hemos enviado para comprobar que la dirección te pertenece',
      close: 'Entendido',
    }
  },
  seasons: {
    title: 'Estaciones',
    welcomemodal: { 
      title: 'Bienvenido a Chungungo',
      message: 'Tienes una cuenta gratuita que te permitirá conocer parte de nuestras experiencias. Si quieres suscribirte para acceder a todas las experiencias, haz click en el botón de abajo. \n\nConoce por 10 días de manera gratuita todas las experiencias y  contenidos disponibles con nuestra suscripción.',
      close: 'Seguir en cuenta gratuita',
      subscribe: 'Suscribirse a Chungungo',
    }
  },
  season: {
    title: 'Experiencias'
  },
  category: {
    types: {
      seasons: 'Estaciones',
      stories: 'Cuentos',
      puppets: 'Cuentos con títeres',
      songs: 'Canciones',
      poems: 'Juego de palabras',
      meet: 'Conozcamos a',
      crafts: 'Manualidades',
      workshops: 'Talleres',
      games: 'Juegos',
      others: 'Guía de uso',
      search: 'Resultados de búsqueda',
    }
  },
  filters: {
    verbal: 'Lenguaje Verbal',
    artistic: 'Lenguajes Artísticos',
    identity: 'Identidad y Autonomía',
    coexistence: 'Convivencia y Ciudadanía',
    movement: 'Corporal y Movimiento',
    exploration: 'Exploración del Entorno Natural',
    understanding: 'Comprensión del Entorno Sociocultural',
    mathinking: 'Pensamiento Matemático',
    lvl01: 'Nivel 1 - A partir de 2-3 años',
    lvl02: 'Nivel 2 - A partir de 3-4 años',
    lvl03: 'Nivel 3 - A partir de 4-6 años',
    all: 'Para todas las edades',
    listen: 'Escuchar',
    create: 'Crear',
    move: 'Moverse',
    look: 'Mirar',
    sing: 'Cantar',
    express: 'Expresar',
    think: 'Pensar',
    mammals: 'Mamíferos',
    birds: 'Aves',
    insects: 'Insectos',
    reptiles: 'Reptiles',
    flora: 'Flora',
    specials: 'Especiales',
    tutorials: 'Tutoriales & Ayuda'
  },
  explore: {
    featured: 'Estaciones destacadas',
    new: 'Estaciones recién actualizadas',
    continue: 'Continuar viendo',
    mostwatched: 'Estaciones más vistas',
    visitagain: 'Volver a visitar',
    all: 'Todas las Estaciones',
  },
  account: {
    title: 'Mi cuenta',
    button: {
      logout: 'Logout'
    },
    notsubscribed: { 
      message: 'Suscríbete y accede a todas las experiencias actuales y futuras de Chungungo. Pruébala gratis por 10 días sin restricciones. Son solo dos pasos y ya serás parte de nuestra comunidad. \n\nPuedes elegir un plan mensual, semestral o anual, como tú prefieras.',
      subscribe: 'Suscríbete aquí',
    }
  },
  subscription: { 
    subscribeconfirm_monthly:{

      title: 'Suscripción mensual a Chungungo',
      message:'Accede a todas las experiencias de manera ilimitada, las veces que quieras, incluyendo las nuevas actualizaciones que se publiquen en el futuro. Recuerda: comenzaremos a cobrar tu suscripción en 10 días a partir de hoy.',
      price: '$6.950',
    },
    subscribeconfirm_quarterly: {
      title: 'Suscripción trimestral a Chungungo',
      message: 'Un plan con los mismos accesos que el plan Mensual pero pagando cada tres meses más un descuento. Como siempre: comenzaremos a cobrar tu suscripción en 10 días a partir de hoy. ',
      price: '$20.000',
    },
    subscribeconfirm_biannual: {
      title: 'Suscripción semestral a Chungungo',
      message: '¿Estás convencido de querer usar Chungungo por un buen tiempo? Toma la suscripción Semestral, paga cada 6 meses y recibe un descuento adicional. comenzaremos a cobrar tu suscripción en 10 días a partir de hoy.',
      price: '$40.000',
    },
    subscribeconfirm_annual: {
      title: 'Suscripción anual a Chungungo',
      message: '¿Eres fan de Chungungo y prefieres pagar solo una vez al año? Entonces la suscripción Anual es perfecta para ti. Paga cada 12 meses y paga menos por mes que en todos los otros planes. Y si: comenzaremos a cobrar tu suscripción en 10 días a partir de hoy. ',
      price: '$75.900',
    },
    subscribesucces: {
      title: 'Te has suscrito exitosamente a Chungungo.',
      subtitle: '¡Qué alegría!',
      message: 'Recibirás un correo con los detalles de tu suscripción. Y recuerda: tu suscripción comenzará a cobrarse en 10 días más a partir de hoy. Cualquier duda o problema, escríbenos a',
      mail: 'contacto@chungungo.com',
      close: 'Ahora, a Hacer Cosas Juntos',
    },
    modal_onlysubscribers: { 
      title: 'Experiencia solo disponible para suscriptores Chungungo',
      message: 'Suscríbete a Chungungo y obtén 10 días de prueba gratis. Accede a todas nuestras experiencias, o si prefieres, sigue navegando y accede a los contenidos libres de Chungungo.',
      subscribe: 'Probar la Suscripción Chungungo',
      close: 'Seguir navegando',
    }
  }
};

export default translations;